// Copyright 2023, Imprivata, Inc.  All rights reserved.

export const WEB_APP_NAME = 'app-access-web';
